import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en/en.json";
import ar from "./locales/ar/ar.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar }
    },
    fallbackLng: "en",
    detection: {
      order: ["localStorage", "navigator"], // check localStorage first
      caches: ["localStorage"], // save in localStorage
      lookupLocalStorage: "i18nextLang" // your key name
    },
    interpolation: { escapeValue: false },
    supportedLngs: ["en", "ar"],
    nonExplicitSupportedLngs: true
  });

i18n.on("languageChanged", (lng) => {
  document.documentElement.setAttribute("dir", lng === "ar" ? "rtl" : "ltr");
  document.documentElement.setAttribute("lang", lng);
});

const initialLng = i18n.language || "en";
document.documentElement.setAttribute("dir", initialLng.startsWith("ar") ? "rtl" : "ltr");
document.documentElement.setAttribute("lang", initialLng);

export default i18n;
